import {Vehicle} from "./vehicle";
export class RecentTrip {
  active: boolean;
  startTime: string;
  distance: number;
  time: number;
  sessionId: string;
  endTime: string;
  first_stop: string;
  last_stop: string;
  avgSpeed: number;
  maxSpeed: number;
  vehicleId: string;
  routeName: string;
  routeId: string;
  endStopName: string;
  startStopName: string;
  vehicle: Vehicle;
  checkoutType: string;
  overSpeedCount: number;


  constructor(sessionId: string, vehicle?: Vehicle, time?: string, routeName?: string, routeId?: string, startStopName?: string, endStopName?: string, checkoutType?: string, overSpeedCount?: number) {
    this.sessionId = sessionId;
    this.active = vehicle ? vehicle.isActive : false;
    this.vehicleId = vehicle ? vehicle.vehicleId : null;
    this.startTime = time;
    this.routeName = routeName;
    this.routeId = routeId;
    this.startStopName = startStopName;
    this.endStopName = endStopName;
    this.vehicle = vehicle;
    this.checkoutType = checkoutType;
    this.overSpeedCount = overSpeedCount || 0;
  }
}

